import { Injectable } from '@angular/core';
import {
  NumberQuestion,
  QuestionBase,
  HiddenQuestion,
  TextareaQuestion,
  DatetimeQuestion
} from 'core/components/forms';
import { Client } from 'core/models/client';
import { CoreQuestionsFactoryService } from 'core/services/core-questions-factory.service';
import { Subscription } from 'core/models/subscription';

@Injectable()
export class CreditsQuestionsService {
  constructor(protected factory: CoreQuestionsFactoryService) {}

  getQuestions(creditsBag: Subscription, client?: Client) {
    const now = new Date();
    const hasStartDatePassed = creditsBag && now > new Date(creditsBag.startDate);
    const isBagExpired = creditsBag && creditsBag.endDate && now > new Date(creditsBag.endDate);
    const questions: QuestionBase<any>[] = [
      this.getClientQuestion(creditsBag, client),
      new NumberQuestion({
        key: 'rateLimit',
        class: 'col-2-offset',
        label: 'credits.totalCredits',
        editable: !isBagExpired,
        value: creditsBag ? creditsBag.rateLimit : null,
        validators: { required: true },
        order: 1
      }),
      new DatetimeQuestion({
        key: 'startDate',
        label: 'nouns.startDate',
        class: 'col-2',
        timezone: client?.timezone || 'utc',
        defaultHour: 0,
        defaultMinute: 0,
        defaultSeconds: 0,
        value: creditsBag
          ? creditsBag.startDate
          : client.type === 'expert' || client.type === 'expertClient'
          ? now
          : null,
        editable: !hasStartDatePassed && client.type !== 'expert' && client.type !== 'expertClient',
        validators: { required: true, invalidDate: true },
        order: 3
      }),
      new TextareaQuestion({
        key: 'comments',
        label: 'credits.header.comments',
        class: 'col-1',
        value: creditsBag ? creditsBag.comments : null,
        order: 5
      })
    ];
    if (client.type !== 'expert' && client.type !== 'expertClient') {
      questions.push(
        new DatetimeQuestion({
          key: 'endDate',
          label: 'nouns.expirationDate',
          class: 'col-2',
          timezone: client?.timezone || 'utc',
          defaultHour: 23,
          defaultMinute: 59,
          defaultSeconds: 59,
          value: creditsBag ? creditsBag.endDate : null,
          validators: { required: true, invalidDate: true },
          order: 4
        })
      );
    }

    if (creditsBag) {
      questions.push(
        new NumberQuestion({
          key: 'rateConsumed',
          class: 'col-2-offset',
          label: 'credits.consumedCredits',
          value: creditsBag ? creditsBag.rateConsumed : null,
          editable: false,
          order: 2
        })
      );
    }

    return questions.sort((a, b) => a.order - b.order);
  }

  getClientQuestion(creditsBag: Subscription, client?: Client): QuestionBase<any> {
    if (creditsBag || client) {
      return new HiddenQuestion({
        key: 'clientId',
        value: creditsBag ? creditsBag.clientId : client.id,
        validators: { required: true },
        order: 0
      });
    }
    return this.factory.getClientQuestion({
      client,
      validators: { required: true }
    });
  }
}
